import { faCircleCheck, faClose, faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

function Popup({ onClose, alertType, message }) {
  const isSuccess = alertType === "success";
  return (
    <div className="fixed top-5 right-5 max-w-xs rounded-gx border border-gx-border shadow-gx p-4 z-popup bg-gx-surface">
      <button
        type="button"
        aria-label="Dismiss"
        className="float-right h-8 w-8 inline-flex items-center justify-center text-gx-red"
        onClick={onClose}
      >
        <FontAwesomeIcon icon={faClose} />
      </button>
      <div className="flex items-center gap-3 mt-6">
        <FontAwesomeIcon
          icon={isSuccess ? faCircleCheck : faWarning}
          className={`text-3xl ${isSuccess ? "text-gx-teal" : "text-gx-red"}`}
        />
        <p className="text-gx-ink font-medium text-sm">{message}</p>
      </div>
    </div>
  );
}

export default Popup;
